import { Component, Input } from '@angular/core';
import { CriticalPointAssignmentLog } from 'src/app/modules/practical-module-logs/models/practical-module-log.model';

@Component({
  selector: 'app-critical-point-assignment-log-item-content',
  templateUrl: './critical-point-assignment-log-item-content.component.html',
  styleUrls: ['./critical-point-assignment-log-item-content.component.scss']
})
export class CriticalPointAssignmentLogItemContentComponent {
  @Input() criticalPointAssingmentLog:CriticalPointAssignmentLog;

  /**
   * Determines if the log has data to show.
   * 
   * @returns true if the log has data to show, false otherwise
   */
  protected hasNoLogData():boolean {
    return this.criticalPointAssingmentLog.oldData == null && this.criticalPointAssingmentLog.newData == null;
  }
}
